import { useNavigate } from "react-router-dom";
import { X, Heart } from "lucide-react";
import { useSavedLooks } from "../contexts/SavedLooksContext";

export default function WishlistLoginPrompt() {
  const { showLoginPrompt, dismissLoginPrompt } = useSavedLooks();
  const navigate = useNavigate();

  if (!showLoginPrompt) return null;

  const handleGoogleLogin = () => {
    dismissLoginPrompt();
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const handleEmailLogin = () => {
    dismissLoginPrompt();
    navigate("/login", { state: { from: window.location.pathname } });
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center" onClick={dismissLoginPrompt}>
      <div className="absolute inset-0 bg-black/30" />
      <div className="relative bg-white w-[340px] max-w-[90vw] p-6 shadow-xl animate-in fade-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()}>
        <button onClick={dismissLoginPrompt} className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-[#676664]/50 hover:text-[#282828]" data-testid="login-prompt-close">
          <X className="w-4 h-4" />
        </button>

        <div className="text-center mb-5">
          <div className="w-12 h-12 bg-[#F0E8DC] flex items-center justify-center mx-auto mb-3">
            <Heart className="w-5 h-5 text-[#9A7B4F]" strokeWidth={1.5} />
          </div>
          <h3 className="text-[16px] text-[#282828] font-medium mb-1">Save to your wishlist</h3>
          <p className="text-[12px] text-[#676664] font-light">Sign in to save pieces you love</p>
        </div>

        <button
          onClick={handleGoogleLogin}
          className="w-full flex items-center justify-center gap-2 py-2.5 border border-[#282828]/15 text-[12px] text-[#282828] hover:bg-[#f5f3f0] transition-colors mb-3"
          data-testid="google-login-btn"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
          Continue with Google
        </button>

        <button
          onClick={handleEmailLogin}
          className="w-full py-2.5 bg-[#9A7B4F] hover:bg-[#8B6B3F] text-white text-[11px] tracking-[0.12em] uppercase transition-colors"
          data-testid="email-login-btn"
        >
          Sign in with Email
        </button>
      </div>
    </div>
  );
}
